import React from "react";
import "../css/KycSectionPepSanctionWithScreening.css";
import "../css/KycSectionAdverseMediaWithScreening.css";
import { Block } from "./ViewUI";

// ✅ reuse your real component to get the exact same bottom UI
import KycSectionAdverseMediaWithScreening from "../common/KycSectionAdverseMediaWithScreening";

export default function KycViewAdverseMedia({ sectionNo = 0, form }) {
  const adverseMedia = form?.adverseMedia || {};
  const screening = form?.internalUse?.adverseMediaScreening || null;

  const comment = String(adverseMedia?.comment || "").trim();
  const aiSummaryLines = Array.isArray(screening?.aiSummary?.lines)
    ? screening.aiSummary.lines.filter(Boolean)
    : [];
  const hasComplianceAssessmentContent = !!comment || aiSummaryLines.length > 0;

  return (
    <div className="card kycCard mb-3 kycAdverseMediaSection">
      <div className="kycSectionHead position-relative">
        <h5 className="kycSectionTitle mb-0">
          {sectionNo ? `${sectionNo} | ` : ""}Adverse Media
        </h5>
      </div>

      <div className="kycSectionBody">
        {/* ✅ BOTTOM PART: EXACT SAME AS KYC FORM PAGE */}
        <div className="kycAdverseBottomLikeForm">
          <KycSectionAdverseMediaWithScreening
            sectionNo={sectionNo}
            form={form}
            readOnly={true}
            embedded={true} // ✅ key line
            hideComplianceAssessmentCard={true}
            complianceAssessmentContent={
              hasComplianceAssessmentContent ? (
              <div className="row g-3">
                <div className="col-12">
                  <div>
                    <div
                      className="rounded-3 p-3"
                      style={{
                        background: "#F9F7F5",
                        border: "1px solid #DBD6D2",
                        marginBottom: 20,
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "Roboto, Arial, sans-serif",
                          fontSize: 18,
                          fontWeight: 500,
                          color: "#8B807B",
                          marginBottom: 14,
                        }}
                      >
                        {comment ? "Compliance assessment" : "Summary of findings"}
                      </div>

                      <div className="d-grid" style={{ gap: 18 }}>
                        {comment ? (
                          <Block label="Compliance comment" value={comment} />
                        ) : null}

                        <div>
                          <div
                            className="kycInfoViewLabel"
                            style={{ marginBottom: 8 }}
                          >
                            AI-generated summary of findings
                          </div>

                          {aiSummaryLines.length ? (
                            <ul className="small text-muted mb-0 ps-3">
                              {aiSummaryLines.slice(0, 10).map((line, i) => (
                                <li key={i}>{line}</li>
                              ))}
                            </ul>
                          ) : (
                            <div className="kycInfoViewText">—</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              ) : null
            }
          />
        </div>
        {/* <div className="kycAdverseBottomLikeForm">
          <KycSectionAdverseMediaWithScreening
            sectionNo={sectionNo}
            form={form}
            readOnly={true}
          
          />
        </div> */}
      </div>
    </div>
  );
}
